export interface WebUIElements {
  [key: string]: any;
}

export function createWebUIElements(): WebUIElements {
  return {
  themeSwitcher: document.querySelector("#themeSwitcher"),
  languageSelect: document.querySelector("#languageSelect"),
  sidebar: document.querySelector("#sidebar"),
  sidebarResizeHandle: document.querySelector("#sidebarResizeHandle"),
  sidebarResizeShield: document.querySelector("#sidebarResizeShield"),
  authSourceGroup: document.querySelector("#authSourceGroup"),
  authSourceDetail: document.querySelector("#authSourceDetail"),
  apiSourceSettingsButton: document.querySelector("#apiSourceSettingsButton"),
  githubLink: document.querySelector("#githubLink"),
  apiStatus: document.querySelector("#apiStatus"),
  versionInfo: document.querySelector("#versionInfo"),
  versionLabel: document.querySelector("#versionLabel"),
  versionUpdateBadge: document.querySelector("#versionUpdateBadge"),
  versionModal: document.querySelector("#versionModal"),
  versionModalClose: document.querySelector("#versionModalClose"),
  versionModalStatus: document.querySelector("#versionModalStatus"),
  versionCurrent: document.querySelector("#versionCurrent"),
  versionLatest: document.querySelector("#versionLatest"),
  versionSource: document.querySelector("#versionSource"),
  versionReleaseHistory: document.querySelector("#versionReleaseHistory"),
  versionOnboardingNotice: document.querySelector("#versionOnboardingNotice"),
  versionOnboardingBody: document.querySelector("#versionOnboardingBody"),
  versionReleaseLink: document.querySelector("#versionReleaseLink"),
  versionStandardDownloadLink: document.querySelector("#versionStandardDownloadLink"),
  versionUpdateButton: document.querySelector("#versionUpdateButton"),
  versionContinuePortableButton: document.querySelector("#versionContinuePortableButton"),
  versionDismissOnboardingButton: document.querySelector("#versionDismissOnboardingButton"),
  apiDirectSettingsButton: document.querySelector("#apiDirectSettingsButton"),
  queueButton: document.querySelector("#queueButton"),
  queueStatusText: document.querySelector("#queueStatusText"),
  mobileTaskBadge: document.querySelector("#mobileTaskBadge"),
  taskNotificationButton: document.querySelector("#taskNotificationButton"),
  taskNotificationBadge: document.querySelector("#taskNotificationBadge"),
  taskNotificationCenter: document.querySelector("#taskNotificationCenter"),
  taskNotificationUnreadSummary: document.querySelector("#taskNotificationUnreadSummary"),
  taskNotificationClearButton: document.querySelector("#taskNotificationClearButton"),
  taskNotificationList: document.querySelector("#taskNotificationList"),
  taskNotificationToastRegion: document.querySelector("#taskNotificationToastRegion"),
  taskNotificationInApp: document.querySelector("#taskNotificationInApp"),
  taskNotificationSystem: document.querySelector("#taskNotificationSystem"),
  taskHistoryShell: document.querySelector(".task-history-shell"),
  sidebarContent: document.querySelector(".sidebar-content"),
  taskActiveList: document.querySelector("#taskActiveList"),
  taskList: document.querySelector("#taskList"),
  taskSearch: document.querySelector("#taskSearch"),
  taskSearchClearButton: document.querySelector("#taskSearchClearButton"),
  taskFilterButton: document.querySelector("#taskFilterButton"),
  taskFilterPopover: document.querySelector("#taskFilterPopover"),
  taskFilterClearButton: document.querySelector("#taskFilterClearButton"),
  taskFilterActiveCount: document.querySelector("#taskFilterActiveCount"),
  taskRatioFilter: document.querySelector("#taskRatioFilter"),
  taskOrientationFilter: document.querySelector("#taskOrientationFilter"),
  taskPromptFidelityFilter: document.querySelector("#taskPromptFidelityFilter"),
  taskResolutionFilter: document.querySelector("#taskResolutionFilter"),
  taskHistoryTopAnchors: document.querySelector("#taskHistoryTopAnchors"),
  taskHistoryBottomAnchors: document.querySelector("#taskHistoryBottomAnchors"),
  taskHistoryLibrarySlot: document.querySelector("#taskHistoryLibrarySlot"),
  archiveButton: document.querySelector("#archiveButton"),
  batchManageButton: document.querySelector("#batchManageButton"),
  batchToolbar: document.querySelector("#batchToolbar"),
  batchSelectedCount: document.querySelector("#batchSelectedCount"),
  batchArchiveButton: document.querySelector("#batchArchiveButton"),
  batchDeleteButton: document.querySelector("#batchDeleteButton"),
  batchCancelButton: document.querySelector("#batchCancelButton"),
  archiveModal: document.querySelector("#archiveModal"),
  archiveModalClose: document.querySelector("#archiveModalClose"),
  archiveList: document.querySelector("#archiveList"),
  archiveCount: document.querySelector("#archiveCount"),
  systemSettingsModal: document.querySelector("#systemSettingsModal"),
  systemSettingsModalClose: document.querySelector("#systemSettingsModalClose"),
  systemSettingsTabs: document.querySelector("#systemSettingsTabs"),
  systemSettingsApiTab: document.querySelector("#systemSettingsApiTab"),
  systemSettingsCodexTab: document.querySelector("#systemSettingsCodexTab"),
  systemSettingsLanguageTab: document.querySelector("#systemSettingsLanguageTab"),
  systemSettingsStorageTab: document.querySelector("#systemSettingsStorageTab"),
  systemSettingsApiPanel: document.querySelector("#systemSettingsApiPanel"),
  systemSettingsCodexPanel: document.querySelector("#systemSettingsCodexPanel"),
  systemSettingsLanguagePanel: document.querySelector("#systemSettingsLanguagePanel"),
  systemSettingsStoragePanel: document.querySelector("#systemSettingsStoragePanel"),
  languageSettingsStatus: document.querySelector("#languageSettingsStatus"),
  settingsStatus: document.querySelector("#settingsStatus"),
  settingsInputRoot: document.querySelector("#settingsInputRoot"),
  settingsOutputRoot: document.querySelector("#settingsOutputRoot"),
  settingsGalleryRoot: document.querySelector("#settingsGalleryRoot"),
  settingsSourceDataRoot: document.querySelector("#settingsSourceDataRoot"),
  saveSettingsButton: document.querySelector("#saveSettingsButton"),
  apiSettingsStatus: document.querySelector("#apiSettingsStatus"),
  apiSettingsActions: document.querySelector("#apiSettingsActions"),
  codexSettingsStatus: document.querySelector("#codexSettingsStatus"),
  apiProviderQuick: document.querySelector("#apiProviderQuick"),
  codexMode: document.querySelector("#codexMode"),
  codexModeGroup: document.querySelector("#codexModeGroup"),
  codexModeNotes: document.querySelectorAll("[data-codex-mode-note]"),
  apiProvider: document.querySelector("#apiProvider"),
  apiProviderSection: document.querySelector("#apiProviderSection"),
  apiProviderCount: document.querySelector("#apiProviderCount"),
  apiProviderSearch: document.querySelector("#apiProviderSearch"),
  apiProviderList: document.querySelector("#apiProviderList"),
  apiProviderDetail: document.querySelector("#apiProviderDetail"),
  apiProviderDetailBaseUrl: document.querySelector("#apiProviderDetailBaseUrl"),
  apiProviderDetailKey: document.querySelector("#apiProviderDetailKey"),
  apiProviderDetailMode: document.querySelector("#apiProviderDetailMode"),
  apiProviderDetailConcurrency: document.querySelector("#apiProviderDetailConcurrency"),
  apiProviderEditor: document.querySelector("#apiProviderEditor"),
  apiProviderEditorTitle: document.querySelector("#apiProviderEditorTitle"),
  apiProviderName: document.querySelector("#apiProviderName"),
  editApiProviderButton: document.querySelector("#editApiProviderButton"),
  copyApiProviderButton: document.querySelector("#copyApiProviderButton"),
  addApiProviderButton: document.querySelector("#addApiProviderButton"),
  sortApiProvidersButton: document.querySelector("#sortApiProvidersButton"),
  deleteApiProviderButton: document.querySelector("#deleteApiProviderButton"),
  cancelApiProviderEditButton: document.querySelector("#cancelApiProviderEditButton"),
  saveApiProviderEditButton: document.querySelector("#saveApiProviderEditButton"),
  apiBaseUrl: document.querySelector("#apiBaseUrl"),
  apiRequestEndpointPreview: document.querySelector("#apiRequestEndpointPreview"),
  apiKey: document.querySelector("#apiKey"),
  apiKeyRevealButton: document.querySelector("#apiKeyRevealButton"),
  apiMode: document.querySelector("#apiMode"),
  apiImageModel: document.querySelector("#apiImageModel"),
  apiImagesConcurrency: document.querySelector("#apiImagesConcurrency"),
  newTaskButton: document.querySelector("#newTaskButton"),
  imageInput: document.querySelector("#imageInput"),
  referenceFileSelection: document.querySelector("#referenceFileSelection"),
  imageEditorModal: document.querySelector("#imageEditorModal"),
  imageEditorClose: document.querySelector("#imageEditorClose"),
  imageEditorSubtitle: document.querySelector("#imageEditorSubtitle"),
  imageEditorCanvas: document.querySelector("#imageEditorCanvas"),
  imageEditorCanvasWrap: document.querySelector("#imageEditorCanvasWrap"),
  imageEditorKonvaMount: document.querySelector("#imageEditorKonvaMount"),
  imageEditorCropBox: document.querySelector("#imageEditorCropBox"),
  imageEditorToolSelect: document.querySelector("#imageEditorToolSelect"),
  imageEditorToolBrush: document.querySelector("#imageEditorToolBrush"),
  imageEditorToolArrow: document.querySelector("#imageEditorToolArrow"),
  imageEditorToolCrop: document.querySelector("#imageEditorToolCrop"),
  imageEditorToolFill: document.querySelector("#imageEditorToolFill"),
  imageEditorToolEraser: document.querySelector("#imageEditorToolEraser"),
  imageEditorInsertList: document.querySelector("#imageEditorInsertList"),
  imageEditorLayerList: document.querySelector("#imageEditorLayerList"),
  imageEditorLayerUp: document.querySelector("#imageEditorLayerUp"),
  imageEditorLayerDown: document.querySelector("#imageEditorLayerDown"),
  imageEditorLayerDelete: document.querySelector("#imageEditorLayerDelete"),
  imageEditorColor: document.querySelector("#imageEditorColor"),
  imageEditorStroke: document.querySelector("#imageEditorStroke"),
  imageEditorStrokeValue: document.querySelector("#imageEditorStrokeValue"),
  imageEditorUndo: document.querySelector("#imageEditorUndo"),
  imageEditorRedo: document.querySelector("#imageEditorRedo"),
  imageEditorReset: document.querySelector("#imageEditorReset"),
  imageEditorSave: document.querySelector("#imageEditorSave"),
  imageEditorCancel: document.querySelector("#imageEditorCancel"),
  imageEditorStatus: document.querySelector("#imageEditorStatus"),
  recentAssetDock: document.querySelector("#recentAssetDock"),
  recentAssetList: document.querySelector("#recentAssetList"),
  referenceCollector: document.querySelector("#referenceCollector"),
  imageStrip: document.querySelector("#imageStrip"),
  imageThumbList: document.querySelector("#imageThumbList"),
  imageThumbItems: document.querySelector("#imageThumbItems"),
  imageUploaderGrid: document.querySelector(".image-uploader-grid"),
  imageUploadSource: document.querySelector("#imageUploadSource"),
  quickGalleryDock: document.querySelector("#quickGalleryDock"),
  quickGalleryOpenButton: document.querySelector("#quickGalleryOpenButton"),
  quickGalleryModal: document.querySelector("#quickGalleryModal"),
  quickGalleryModalClose: document.querySelector("#quickGalleryModalClose"),
  quickGalleryDoneButton: document.querySelector("#quickGalleryDoneButton"),
  quickGallerySearch: document.querySelector("#quickGallerySearch"),
  quickGalleryList: document.querySelector("#quickGalleryList"),
  quickGalleryRail: document.querySelector("#quickGalleryRail"),
  modalTabGallery: document.querySelector("#modalTabGallery"),
  modalTabBrand: document.querySelector("#modalTabBrand"),
  quickGalleryTabContent: document.querySelector("#quickGalleryTabContent"),
  quickBrandTabContent: document.querySelector("#quickBrandTabContent"),
  brandMaterialSummaryText: document.querySelector("#brandMaterialSummaryText"),
  brandMaterialPicker: document.querySelector("#brandMaterialPicker"),
  brandMaterialList: document.querySelector("#brandMaterialList"),
  brandMaterialOpenButton: document.querySelector("#brandMaterialOpenButton"),
  brandMaterialDrawer: document.querySelector("#brandMaterialDrawer"),
  brandMaterialDrawerTitle: document.querySelector("#brandMaterialDrawerTitle"),
  brandMaterialDrawerSummary: document.querySelector("#brandMaterialDrawerSummary"),
  brandMaterialDrawerClose: document.querySelector("#brandMaterialDrawerClose"),
  brandMaterialDrawerBackdrop: document.querySelector("#brandMaterialDrawerBackdrop"),
  brandMaterialDrawerCancel: document.querySelector("#brandMaterialDrawerCancel"),
  brandMaterialDrawerConfirm: document.querySelector("#brandMaterialDrawerConfirm"),
  brandMaterialDrawerList: document.querySelector("#brandMaterialDrawerList"),
  brandMaterialDrawerEmpty: document.querySelector("#brandMaterialDrawerEmpty"),
  brandMaterialSearch: document.querySelector("#brandMaterialSearch"),
  brandMaterialFilterLabel: document.querySelector("#brandMaterialFilterLabel"),
  galleryManagePanel: document.querySelector("#galleryManagePanel"),
  galleryManageButton: document.querySelector("#galleryManageButton"),
  galleryDrawer: document.querySelector("#galleryDrawer"),
  galleryDrawerClose: document.querySelector("#galleryDrawerClose"),
  galleryDrawerBackdrop: document.querySelector("#galleryDrawerBackdrop"),
  galleryModeTabReference: document.querySelector("#galleryModeTabReference"),
  galleryModeTabBrand: document.querySelector("#galleryModeTabBrand"),
  galleryReferenceToolbar: document.querySelector("#galleryReferenceToolbar"),
  galleryBrandSection: document.querySelector("#galleryBrandSection"),
  galleryDrawerSubtitle: document.querySelector("#galleryDrawerSubtitle"),
  galleryDrawerCategoryTabs: document.querySelector("#galleryDrawerCategoryTabs"),
  galleryCategoryManagePanel: document.querySelector("#galleryCategoryManagePanel"),
  galleryCategoryManageToggle: document.querySelector("#galleryCategoryManageToggle"),
  galleryCategoryList: document.querySelector("#galleryCategoryList"),
  newGalleryCategoryName: document.querySelector("#newGalleryCategoryName"),
  newGalleryCategoryPromptRole: document.querySelector("#newGalleryCategoryPromptRole"),
  addGalleryCategoryButton: document.querySelector("#addGalleryCategoryButton"),
  galleryGrid: document.querySelector("#galleryGrid"),
  addToGalleryModal: document.querySelector("#addToGalleryModal"),
  addToGalleryClose: document.querySelector("#addToGalleryClose"),
  addToGalleryPreview: document.querySelector("#addToGalleryPreview"),
  galleryNameInput: document.querySelector("#galleryNameInput"),
  galleryCategoryInput: document.querySelector("#galleryCategoryInput"),
  galleryPromptNoteInput: document.querySelector("#galleryPromptNoteInput"),
  saveToGalleryButton: document.querySelector("#saveToGalleryButton"),
  clearImagesButton: document.querySelector("#clearImagesButton"),
  pasteClipboardButton: document.querySelector("#pasteClipboardButton"),
  prompt: document.querySelector("#prompt"),
  promptEditor: document.querySelector("#promptEditor"),
  promptTemplateButton: document.querySelector("#promptTemplateButton"),
  promptTemplateRecentDock: document.querySelector("#promptTemplateRecentDock"),
  promptTemplateDrawer: document.querySelector("#promptTemplateDrawer"),
  promptTemplateDrawerClose: document.querySelector("#promptTemplateDrawerClose"),
  promptTemplateDrawerBackdrop: document.querySelector("#promptTemplateDrawerBackdrop"),
  promptTemplateSummary: document.querySelector("#promptTemplateSummary"),
  promptTemplateSearch: document.querySelector("#promptTemplateSearch"),
  promptTemplateSearchClearButton: document.querySelector("#promptTemplateSearchClearButton"),
  promptTemplateCreateButton: document.querySelector("#promptTemplateCreateButton"),
  promptTemplateImportButton: document.querySelector("#promptTemplateImportButton"),
  promptTemplateImportInput: document.querySelector("#promptTemplateImportInput"),
  promptTemplateExportButton: document.querySelector("#promptTemplateExportButton"),
  promptTemplateCategoryList: document.querySelector("#promptTemplateCategoryList"),
  promptTemplateCategoryManageButton: document.querySelector("#promptTemplateCategoryManageButton"),
  promptTemplateCategoryPanel: document.querySelector("#promptTemplateCategoryPanel"),
  promptTemplateList: document.querySelector("#promptTemplateList"),
  promptTemplateDetail: document.querySelector("#promptTemplateDetail"),
  promptTemplateForm: document.querySelector("#promptTemplateForm"),
  mentionSuggest: document.querySelector("#mentionSuggest"),
  colorSuggest: document.querySelector("#colorSuggest"),
  charCount: document.querySelector("#charCount"),
  clearPromptButton: document.querySelector("#clearPromptButton"),
  promptFindButton: document.querySelector("#promptFindButton"),
  promptFindPanel: document.querySelector("#promptFindPanel"),
  promptFindInput: document.querySelector("#promptFindInput"),
  promptReplaceInput: document.querySelector("#promptReplaceInput"),
  promptFindCount: document.querySelector("#promptFindCount"),
  promptFindStatus: document.querySelector("#promptFindStatus"),
  promptFindClose: document.querySelector("#promptFindClose"),
  modeSettingsSlot: document.querySelector("#modeSettingsSlot"),
  outputSettingsHeader: document.querySelector("#outputSettingsHeader"),
  outputSettingsLockButton: document.querySelector("#outputSettingsLockButton"),
  outputSettingsLockedSummary: document.querySelector("#outputSettingsLockedSummary"),
  outputSettingsSummaryContent: document.querySelector("#outputSettingsSummaryContent"),
  outputSettingsTaskAction: document.querySelector("#outputSettingsTaskAction"),
  adoptTaskOutputSettingsButton: document.querySelector("#adoptTaskOutputSettingsButton"),
  modeSpecificSettings: document.querySelector("#modeSpecificSettings"),
  mainModelField: document.querySelector("#mainModelField"),
  mainModelCombobox: document.querySelector("#mainModelCombobox"),
  mainModel: document.querySelector("#mainModel"),
  mainModelToggle: document.querySelector("#mainModelToggle"),
  mainModelOptions: document.querySelector("#mainModelOptions"),
  webSearchField: document.querySelector("#webSearchField"),
  webSearch: document.querySelector("#webSearch"),
  promptFidelityField: document.querySelector("#promptFidelityField"),
  promptFidelity: document.querySelector("#promptFidelity"),
  apiDirectSettingsNotice: document.querySelector("#apiDirectSettingsNotice"),
  settingsGrid: document.querySelector("#settingsGrid"),
  model: document.querySelector("#model"),
  size: document.querySelector("#size"),
  sizeModeGroup: document.querySelector("#sizeModeGroup"),
  customSizeToggle: document.querySelector("#customSizeToggle"),
  nInput: document.querySelector("#nInput"),
  nValue: document.querySelector("#nValue"),
  resolution: document.querySelector("#resolution"),
  ratio: document.querySelector("#ratio"),
  orientation: document.querySelector("#orientation"),
  pixelPreview: document.querySelector("#pixelPreview"),
  customSize: document.querySelector("#customSize"),
  customSizeHint: document.querySelector("#customSizeHint"),
  customWidth: document.querySelector("#customWidth"),
  customHeight: document.querySelector("#customHeight"),
  customRatioField: document.querySelector(".custom-ratio-field"),
  customRatioWidth: document.querySelector("#customRatioWidth"),
  customRatioHeight: document.querySelector("#customRatioHeight"),
  customRatioFromImageButton: document.querySelector("#customRatioFromImageButton"),
  swapCustomSizeButton: document.querySelector("#swapCustomSizeButton"),
  quality: document.querySelector("#quality"),
  outputFormat: document.querySelector("#outputFormat"),
  outputFormatField: document.querySelector("#outputFormatField"),
  outputFormatGroup: document.querySelector("#outputFormatGroup"),
  moderation: document.querySelector("#moderation"),
  compressionPopover: document.querySelector("#compressionPopover"),
  compressionField: document.querySelector("#compressionField"),
  compression: document.querySelector("#compression"),
  compressionValue: document.querySelector("#compressionValue"),
  runButton: document.querySelector("#runButton"),
  statusText: document.querySelector("#statusText"),
  previewGrid: document.querySelector("#previewGrid"),
  downloadAllButton: document.querySelector("#downloadAllButton"),
  previewSelectionActions: document.querySelector("#previewSelectionActions"),
  previewSelectionCount: document.querySelector("#previewSelectionCount"),
  downloadSelectedButton: document.querySelector("#downloadSelectedButton"),
  deleteUnselectedOutputsButton: document.querySelector("#deleteUnselectedOutputsButton"),
  refreshButton: document.querySelector("#refreshButton"),
  copyJsonButton: document.querySelector("#copyJsonButton"),
  requestJson: document.querySelector("#requestJson"),
  controlsCol: document.querySelector(".controls-col"),
  previewCol: document.querySelector(".preview-col"),
  previewPanel: document.querySelector(".preview-panel"),
  };
}
